import React from 'react';

interface ObjectControlProps<T extends object> {
  value: T;
  onChange: (newValue: T) => void;
}

export const ObjectControl = <T extends object>({ value, onChange }: ObjectControlProps<T>) => {
  const [prevValue, setPrevValue] = React.useState(value);
  const [stringValue, setStringValue] = React.useState(() => JSON.stringify(value, undefined, '    '));
  if (!Object.is(prevValue, value)) {
    setPrevValue(value);
    setStringValue(JSON.stringify(value, undefined, '    '));
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <textarea
        value={stringValue}
        onChange={(e) => {
          const newStringValue = e.target.value;
          setStringValue(newStringValue);

          try {
            const newValue = JSON.parse(e.target.value);
            onChange(newValue);
          } catch {}
        }}
        rows={stringValue.split('\n').length}
        style={{
          height: '100%',
          width: '100%',
        }}
      ></textarea>
    </div>
  );
};
